import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { ReviewsItem } from '../../components/ReviewsItem';
import { AnswerListContainer } from '../QuestionAnswerList';
import { getQuestionById } from '../../selectors/questions';
import { QuestionContainer } from './Question';
import { AvatarContainer } from './Avatar';
import { AuthorContainer } from './Author';
import { FooterContainer } from './Footer';

interface IQuestionItemContainerProps {
  id: string;
  inPopup?: boolean;
}

export function QuestionItemContainer({ id, inPopup }: IQuestionItemContainerProps) {
  const { areAnswersOpened } = useSelector(getQuestionById(id));

  return (
    <>
      <ReviewsItem
        id={id}
        aside={<AvatarContainer questionId={id} />}
        author={<AuthorContainer questionId={id} />}
        comment={<QuestionContainer questionId={id} />}
        footer={<FooterContainer questionId={id} inPopup={inPopup} />}
      />
      <Responsive desktop>{areAnswersOpened && <AnswerListContainer questionId={id} />}</Responsive>
    </>
  );
}
